import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {
  payloadSubAffDealsV2List,
} from "../../store/admin/subAffDealsV2";

const getList = (data: payloadSubAffDealsV2List) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_deals_v2.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const deleteCondition = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_deals_v2.delete.replace('{id}', `${data.id}`);

  return fetch(`${endpoint}?authenticity_token=${authenticity_token}`, {...RequestOptions('DELETE')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getConstants = () => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.sub_aff_deals_v2.constants}?authenticity_token=${authenticity_token}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const createCondition = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_deals_v2.create;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}

const getCondition = (id: string) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.admin.sub_aff_deals_v2.details
    .replace('{id}', id)}?authenticity_token=${authenticity_token}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const editCondition = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.sub_aff_deals_v2.edit.replace('{id}', `${data.id}`);

  const payload = {
    subaffiliate_condition: data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('PUT', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
}


export const subAffDealsV2Service = {
  getList,
  deleteCondition,
  getConstants,
  createCondition,
  getCondition,
  editCondition,
};
